//@flow
/**
 * Quiz actions
 * @module quiz/actions
 */
import { QUIZ_CONNECTION } from './reducer'

import type { Action } from './reducer'

/**
 * Updates the connection status of the quiz.
 * @memberof quiz/actions
 */
export const updateConnectionStatus = (connected: boolean): Action => ({
  type: QUIZ_CONNECTION,
  payload: connected,
})



// WEBPACK FOOTER //
// ./src/state/quiz/actions.js